export const heroTiles = [
  {
    id: 'immersive-worlds',
    label: 'Immersive Worlds',
    description: 'Bioluminescent forest canopies and glowing skybridges from another realm.',
    image:
      'https://images.unsplash.com/photo-1502082553048-f009c37129b9?auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'editorial-moods',
    label: 'Editorial Moods',
    description: 'Dreamy fashion portrait captured with cinematic studio lighting.',
    image:
      'https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=1200&q=80',
  },
  {
    id: 'concept-playgrounds',
    label: 'Concept Playgrounds',
    description: 'Speculative architecture twisting gravity into playful sculptural forms.',
    image:
      'https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&w=1200&q=80',
  },
];

export const featuredCollections = [
  {
    id: 'neon-dreams',
    title: 'Neon Dreams',
    description: 'Electric cityscapes that glow with cyberpunk neon palettes.',
    cover:
      'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80',
    tags: ['City', 'Cyberpunk', 'Night'],
    previews: [
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=480&q=80',
      'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=480&q=80',
    ],
    curator: 'Curated by Nova Studio',
    stats: { artworks: 8, updated: '2 days ago' },
    shouldGenerate: true,
    artworks: [
      {
        id: 'neon-dreams-01',
        url: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1200&q=80',
        title: 'Neon-lit avenue reflected on wet street',
        prompt:
          'Cyberpunk city street at night, glowing neon signs reflected in rain-soaked pavement, cinematic lighting, ultra wide angle, vibrant magenta and teal palette',
      },
      {
        id: 'neon-dreams-02',
        url: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1200&q=80',
        title: 'Futuristic skyline washed in violet haze',
        prompt:
          'Futuristic skyline emerging through violet haze, towering skyscrapers with holographic billboards, atmospheric perspective, concept art style',
      },
      {
        id: 'neon-dreams-03',
        url: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=1200&q=80',
        title: 'Traveler crossing a cyan-soaked alley',
        prompt:
          'Lone traveler in a neon-lit alley, cyan and magenta glow, reflective puddles, sci-fi noir mood, volumetric light beams',
      },
      {
        id: 'neon-dreams-04',
        url: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&q=80',
        title: 'Magenta towers mirrored in a canal',
        prompt:
          'High-rise towers mirrored in a canal at night, magenta and blue neon signage shimmering on the water, futuristic architecture, hyperreal detail',
      },
      {
        id: 'neon-dreams-05',
        url: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1200&q=80',
        title: 'Skybridge glowing in electric purple',
        prompt:
          'Elevated skybridge glowing electric purple, dense futuristic city below, foggy atmosphere, cinematic concept art',
      },
      {
        id: 'neon-dreams-06',
        url: 'https://images.unsplash.com/photo-1526401281623-276a98be4ada?auto=format&fit=crop&w=1200&q=80',
        title: 'Drone trails painting the skyline',
        prompt:
          'Drones leaving light trails across a neon skyline, wide shot of cyberpunk metropolis at dusk, dynamic motion blur',
      },
      {
        id: 'neon-dreams-07',
        url: 'https://images.unsplash.com/photo-1521572267360-ee0c2909d518?auto=format&fit=crop&w=1200&q=80',
        title: 'Night market bathed in neon light',
        prompt:
          'Bustling night market drenched in neon lights, colorful signage, cinematic cyberpunk ambience, diverse crowd silhouettes',
      },
      {
        id: 'neon-dreams-08',
        url: 'https://images.unsplash.com/photo-1523475472560-d2df97ec485c?auto=format&fit=crop&w=1200&q=80',
        title: 'Electric boulevard under midnight skies',
        prompt:
          'Electric boulevard stretching into the distance under midnight skies, neon reflections, futuristic vehicles, high fidelity render',
      },
    ],
  },
  {
    id: 'organic-forms',
    title: 'Organic Forms',
    description: 'A celebration of flowing shapes inspired by nature and motion.',
    cover:
      'https://images.unsplash.com/photo-1503264116251-35a269479413?auto=format&fit=crop&w=1200&q=80',
    tags: ['Nature', 'Motion', 'Sculptural'],
    previews: [
      'https://images.unsplash.com/photo-1529429617124-aee516021ece?auto=format&fit=crop&w=480&q=80',
      'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=480&q=80',
    ],
    curator: 'Curated by Field & Flow',
    stats: { artworks: 8, updated: '5 days ago' },
    shouldGenerate: true,
    artworks: [
      {
        id: 'organic-forms-01',
        url: 'https://images.unsplash.com/photo-1503264116251-35a269479413?auto=format&fit=crop&w=1200&q=80',
        title: 'Ribboned sculpture carved by the wind',
        prompt:
          'Fluid ribboned sculpture carved by the wind, organic metallic material, minimal gallery lighting, 3D abstract render, soft gradients',
      },
      {
        id: 'organic-forms-02',
        url: 'https://images.unsplash.com/photo-1529429617124-aee516021ece?auto=format&fit=crop&w=1200&q=80',
        title: 'Glass atrium blooming with curved flora',
        prompt:
          'Glass atrium filled with flowing biophilic structures, curved flora-like forms, translucent materials, natural light shafts',
      },
      {
        id: 'organic-forms-03',
        url: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
        title: 'Desert road through red rock mountains',
        prompt:
          'Open highway road running through red rock canyon mountains, desert landscape, rocky valley, scenic travel photography',
      },
      {
        id: 'organic-forms-04',
        url: 'https://images.unsplash.com/photo-1549880338-65ddcdfd017b?auto=format&fit=crop&w=1200&q=80',
        title: 'Abstract marble canyon at sunrise',
        prompt:
          'Abstract marble canyon at sunrise, smooth carved surfaces, warm and cool color interplay, high contrast lighting, digital matte painting',
      },
      {
        id: 'organic-forms-05',
        url: 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=1200&q=80',
        title: 'Copper petals in gentle motion',
        prompt:
          'Copper petals suspended in gentle motion, macro photography, bokeh backdrop, kinetic sculpture aesthetic',
      },
      {
        id: 'organic-forms-06',
        url: 'https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1200&q=80',
        title: 'Ocean flora rendered in translucent silk',
        prompt:
          'Ocean flora rendered in translucent silk fabric, underwater lighting, flowing textiles, artistic fashion photography',
      },
      {
        id: 'organic-forms-07',
        url: 'https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?auto=format&fit=crop&w=1200&q=80',
        title: 'Ceramic waves frozen mid-crest',
        prompt:
          'Ceramic waves frozen mid-crest, matte porcelain texture, soft minimal background, product photography lighting',
      },
      {
        id: 'organic-forms-08',
        url: 'https://images.unsplash.com/photo-1525186402429-b4ff38bedbec?auto=format&fit=crop&w=1200&q=80',
        title: 'Paper-thin leaves caught in motion blur',
        prompt:
          'Paper-thin leaves caught in motion blur, monochrome palette, long exposure abstract fine art, floating forms',
      },
    ],
  },
  {
    id: 'mythic-realms',
    title: 'Mythic Realms',
    description: 'Fantastical environments for storytellers and world builders.',
    cover:
      'https://images.unsplash.com/photo-1472457897821-70d3819a0e24?auto=format&fit=crop&w=1200&q=80',
    tags: ['Fantasy', 'Worldbuilding', 'Illustration'],
    previews: [
      'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?auto=format&fit=crop&w=480&q=80',
      'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=480&q=80',
    ],
    curator: 'Curated by Storyform Labs',
    stats: { artworks: 8, updated: '1 week ago' },
    shouldGenerate: true,
    artworks: [
      {
        id: 'mythic-realms-01',
        url: 'https://images.unsplash.com/photo-1472457897821-70d3819a0e24?auto=format&fit=crop&w=1200&q=80',
        title: 'Castle floating above a moonlit lake',
        prompt:
          'Floating castle above a moonlit lake, fantasy illustration, glowing waterfalls, misty atmosphere, epic concept art',
      },
      {
        id: 'mythic-realms-02',
        url: 'https://images.unsplash.com/photo-1472214103451-9374bd1c798e?auto=format&fit=crop&w=1200&q=80',
        title: 'Sunlit path winding through enchanted woods',
        prompt:
          'Sunlit path winding through enchanted woods, bioluminescent flora, warm golden light, fairytale environment concept art',
      },
      {
        id: 'mythic-realms-03',
        url: 'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1200&q=80',
        title: 'Nebula sky arching over crystalline peaks',
        prompt:
          'Nebula-filled sky arching over crystalline mountain peaks, aurora colors, grand fantasy landscape, matte painting',
      },
      {
        id: 'mythic-realms-04',
        url: 'https://images.unsplash.com/photo-1473654729523-203e25dfda10?auto=format&fit=crop&w=1200&q=80',
        title: 'Aurora swirling above a mystic village',
        prompt:
          'Aurora swirling above a mystic village with lanterns, cozy cottages, snowy night, whimsical storybook style',
      },
      {
        id: 'mythic-realms-05',
        url: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&w=1200&q=80',
        title: 'Moonlit gate leading to ancient keep',
        prompt:
          'Moonlit gate leading to an ancient keep, ornate stonework, enchanted forest, fantasy artwork, atmospheric fog',
      },
      {
        id: 'mythic-realms-06',
        url: 'https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?auto=format&fit=crop&w=1200&q=80',
        title: 'Waterfall shrine guarded by stone sentinels',
        prompt:
          'Waterfall shrine guarded by stone sentinels, glowing runes, mystical pool, high-detail fantasy illustration',
      },
      {
        id: 'mythic-realms-07',
        url: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1200&q=80',
        title: 'Lantern-lit forest clearing at dusk',
        prompt:
          'Lantern-lit forest clearing at dusk, floating fireflies, magical ambience, painterly fantasy scene',
      },
      {
        id: 'mythic-realms-08',
        url: 'https://images.unsplash.com/photo-1520880867055-1e30d1cb001c?auto=format&fit=crop&w=1200&q=80',
        title: 'Arcane waterfall cascading into starlit pool',
        prompt:
          'Arcane waterfall cascading into a starlit pool, glowing glyphs, celestial reflections, epic fantasy art',
      },
    ],
  },
  {
    id: 'arctic-aerials',
    title: 'Arctic Aerials',
    description: 'Sweeping drone vistas of glaciers, fjords, and polar light.',
    cover:
      'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=1200&q=80',
    tags: ['Landscape', 'Aerial', 'Ice'],
    previews: [
      'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?auto=format&fit=crop&w=480&q=80',
      'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=480&q=80',
    ],
    curator: 'Curated by Horizon Collective',
    stats: { artworks: 6, updated: '4 days ago' },
    shouldGenerate: true,
    artworks: [
      {
        id: 'arctic-aerials-01',
        url: 'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1200&q=80',
        title: 'Ice shelf fracturing into the sea',
        prompt:
          'Aerial view of an Arctic ice shelf fracturing into the sea, crisp glacial textures, polar blue palette, cinematic drone photography',
      },
      {
        id: 'arctic-aerials-02',
        url: 'https://images.unsplash.com/photo-1454789548928-9efd52dc4031?auto=format&fit=crop&w=1200&q=80',
        title: 'Glacier veins glowing at twilight',
        prompt:
          'Drone shot above glacier veins glowing at twilight, intricate crevasse patterns, soft cyan light, atmospheric landscape photography',
      },
      {
        id: 'arctic-aerials-03',
        url: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1200&q=80',
        title: 'Snowcapped range under pastel sky',
        prompt:
          'Vast snowcapped mountain range under a pastel dawn sky, misty valleys, painterly atmosphere, epic aerial landscape',
      },
      {
        id: 'arctic-aerials-04',
        url: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
        title: 'Frozen lake carved by the wind',
        prompt:
          'Frozen lake carved by the wind with organic patterns, high altitude perspective, frosty gradients, minimal winter aesthetic',
      },
      {
        id: 'arctic-aerials-05',
        url: 'https://images.unsplash.com/photo-1493815793585-d94ccbc86df0?auto=format&fit=crop&w=1200&q=80',
        title: 'Aurora dancing above coastal cliffs',
        prompt:
          'Northern lights dancing above Arctic coastal cliffs, long exposure light trails, icy water reflections, vibrant greens and violets',
      },
      {
        id: 'arctic-aerials-06',
        url: 'https://images.unsplash.com/photo-1515871204537-9a1c9be8d6c5?auto=format&fit=crop&w=1200&q=80',
        title: 'Polar research station at blue hour',
        prompt:
          'Polar research station captured at blue hour, aerial composition, warm lights against icy landscape, cinematic storytelling',
      },
    ],
  },
  {
    id: 'retro-printworks',
    title: 'Retro Printworks',
    description: 'Bold graphic posters remixing mid-century palettes and typography.',
    cover:
      'https://images.unsplash.com/photo-1489515217757-5fd1be406fef?auto=format&fit=crop&w=1200&q=80',
    tags: ['Graphic', 'Retro', 'Typography'],
    previews: [
      'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=480&q=80',
      'https://images.unsplash.com/photo-1513569771920-c9e1d31714af?auto=format&fit=crop&w=480&q=80',
    ],
    curator: 'Curated by Signal Press',
    stats: { artworks: 6, updated: '3 days ago' },
    shouldGenerate: true,
    artworks: [
      {
        id: 'retro-printworks-01',
        url: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=1200&q=80',
        title: 'Geometric sunrise in sorbet tones',
        prompt:
          'Graphic poster of a geometric sunrise rendered in sorbet tones, grainy print texture, bold sans-serif typography, retro futurist style',
      },
      {
        id: 'retro-printworks-02',
        url: 'https://images.unsplash.com/photo-1513569771920-c9e1d31714af?auto=format&fit=crop&w=1200&q=80',
        title: 'Stacked shapes with offset ink',
        prompt:
          'Stacked abstract shapes with intentional offset ink, dusty orange and teal palette, screen printed effect, mid-century modern aesthetic',
      },
      {
        id: 'retro-printworks-03',
        url: 'https://images.unsplash.com/photo-1462396881884-de2c07cb95ed?auto=format&fit=crop&w=1200&q=80',
        title: 'Layered arches with halftone grain',
        prompt:
          'Layered arches and circles with halftone grain overlay, cream background, minimalist typography, vintage poster layout',
      },
      {
        id: 'retro-printworks-04',
        url: 'https://images.unsplash.com/photo-1545239351-1141bd82e8a6?auto=format&fit=crop&w=1200&q=80',
        title: 'Vibrant travel advert throwback',
        prompt:
          'Vibrant retro travel advert, illustrated coastline, playful lettering, warm gradients, nostalgic 1960s print design',
      },
      {
        id: 'retro-printworks-05',
        url: 'https://images.unsplash.com/photo-1529336953121-497c3c9f9c01?auto=format&fit=crop&w=1200&q=80',
        title: 'Solar system chart in retro inks',
        prompt:
          'Solar system educational chart rendered in retro inks, orbital lines, limited color screen print, bold condensed headings',
      },
      {
        id: 'retro-printworks-06',
        url: 'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&q=80',
        title: 'Typographic festival announcement',
        prompt:
          'Typographic festival announcement poster, modular grid, overlapping letters, neon coral and deep navy palette, risograph texture',
      },
    ],
  },
];

export const curatedPrompts = [
  {
    id: 'aurora-orchestra',
    title: 'Aurora Orchestra',
    prompt:
      'An orchestra performing under a shimmering aurora borealis, rendered in vibrant watercolor.',
    useCases: ['Album art', 'Editorial'],
  },
  {
    id: 'clockwork-garden',
    title: 'Clockwork Garden',
    prompt:
      'Mechanical flowers blooming in a twilight garden, cinematic lighting, macro perspective.',
    useCases: ['Concept art', 'Posters'],
  },
  {
    id: 'astral-library',
    title: 'Astral Library',
    prompt:
      'A library floating among constellations with luminous shelves, intricate digital painting.',
    useCases: ['Book covers', 'Worldbuilding'],
  },
];

export const trendingPrompts = [
  { id: 'bioluminescent-reef', title: 'Bioluminescent Reef', engagements: 1240 },
  { id: 'retro-hologram-portrait', title: 'Retro Hologram Portrait', engagements: 986 },
  { id: 'desert-mirage-metropolis', title: 'Desert Mirage Metropolis', engagements: 842 },
];

export const inspirationBoards = [
  {
    id: 'zen-retreats',
    title: 'Zen Retreats',
    theme: 'Minimalist sanctuaries with soft gradients and natural textures.',
    thumbnails: [
      'https://images.unsplash.com/photo-1519710164239-da123dc03ef4?auto=format&fit=crop&w=400&q=80',
      'https://images.unsplash.com/photo-1493666438817-866a91353ca9?auto=format&fit=crop&w=400&q=80',
      'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=400&q=80',
    ],
  },
  {
    id: 'galactic-odyssey',
    title: 'Galactic Odyssey',
    theme: 'Deep-space vistas, cosmic phenomena, and futuristic travelers.',
    thumbnails: [
      'https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=400&q=80',
      'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?auto=format&fit=crop&w=400&q=80',
      'https://images.unsplash.com/photo-1472457897821-70d3819a0e24?auto=format&fit=crop&w=400&q=80',
    ],
  },
];

export const fallbackImage =
  'https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=600&q=60';
